<template>
  <div class="fotoportada-container" ref="containerRef">
    <!-- Capa de oscurecimiento inferior elegante -->
    <div ref="darkOverlayRef" class="dark-overlay"></div>

    <div class="overlay-content">
      <!-- 1. MIS XV (ARRIBA) -->
      <div ref="misXvWrapperRef" class="mis-xv-wrapper">
        <div class="mis-xv-top">
          MIS XV
        </div>
      </div>

      <!-- 2. BLOQUE CENTRAL: 'R' AL LADO Y 'EGINA EDITH' ABAJO -->
      <div ref="nombreRef" class="centered-container">
        <div class="fila-principal">
          <span class="inicial-script">R</span>
          <span class="resto-nombre">EGINA</span>
        </div>
        <div class="segunda-linea">EDITH</div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'CoverComponent',
  setup() {
    const containerRef = ref(null)
    const nombreRef = ref(null)
    const misXvWrapperRef = ref(null)
    const darkOverlayRef = ref(null)
    let tl = null

    onMounted(async () => {
      await nextTick()

      gsap.config({ force3D: true })

      tl = gsap.timeline({
        defaults: { ease: 'power3.out' }
      })

      // 1. Zoom cinemático suave de la foto de fondo con blur inicial
      tl.fromTo(
        containerRef.value,
        { autoAlpha: 0, scale: 1.08, filter: 'blur(6px)' },
        { autoAlpha: 1, scale: 1, filter: 'blur(0px)', duration: 1.6, ease: 'power2.out' }
      )

      // 2. Aparición del gradiente oscuro inferior
      .fromTo(
        darkOverlayRef.value,
        { autoAlpha: 0 },
        { autoAlpha: 1, duration: 1.2, ease: 'sine.out' },
        '-=1.2'
      )

      // 3. Entrada elegante de "MIS XV" desde arriba con fundido
      .fromTo(
        misXvWrapperRef.value,
        { autoAlpha: 0, y: -25, filter: 'blur(4px)' },
        { autoAlpha: 1, y: 0, filter: 'blur(0px)', duration: 1.1, ease: 'power2.out' },
        '-=1.0'
      )

      // 4. Revelado majestuoso del nombre (R al lado, EGINA EDITH abajo) con elevación fluida
      .fromTo(
        nombreRef.value,
        { autoAlpha: 0, y: 35, scale: 0.96, filter: 'blur(4px)' },
        { autoAlpha: 1, y: 0, scale: 1, filter: 'blur(0px)', duration: 1.3, ease: 'power3.out' },
        '-=0.7'
      )
    })

    onUnmounted(() => {
      if (tl) tl.kill()
    })

    return {
      containerRef,
      nombreRef,
      misXvWrapperRef,
      darkOverlayRef
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;500;600&family=Cormorant+Garamond:ital,wght@0,300;1,300&family=Pinyon+Script&display=swap');

.fotoportada-container {
  position: relative;
  width: 100%;
  height: 95vh;
  overflow: hidden;
  background-image: url('@/assets/DSC_5554 copia_11zon.webp');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  z-index: 1;
  margin-top: -60px;
  will-change: transform, opacity, filter;
  transform: translateZ(0);
}

/* Gradiente inferior para realzar el texto */
.dark-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60%;
  pointer-events: none;
  background: linear-gradient(
    to top,
    rgba(10, 8, 15, 0.85) 0%,
    rgba(10, 8, 15, 0.4) 50%,
    transparent 100%
  );
  z-index: 2;
  will-change: opacity;
}

/* Distribución alineada arriba y centro */
.overlay-content {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 3;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 65px 20px 40px 20px;
  box-sizing: border-box;
  text-align: center;
}

/* 1. MIS XV */
.mis-xv-wrapper {
  margin-bottom: 18px;
  will-change: transform, opacity, filter;
}

.mis-xv-top {
  font-family: 'Cinzel', serif;
  font-size: 16px;
  letter-spacing: 6px;
  color: #fafafa;
  text-transform: uppercase;
  text-shadow: 0 0 12px rgba(243, 229, 171, 0.4);
}

/* 2. BLOQUE DEL NOMBRE */
.centered-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  will-change: transform, opacity, filter;
}

/* Fila superior: La 'R' grande script al lado de 'EGINA' */
.fila-principal {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 2px;
  margin-bottom: -12px;
}

.inicial-script {
  font-family: 'Pinyon Script', cursive;
  font-size: 78px;
  font-weight: 400;
  color: #ffffff;
  line-height: 0.8;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.85), 0 0 25px rgba(212, 175, 55, 0.35);
}

.resto-nombre {
  font-family: 'Cormorant Garamond', 'Cinzel', serif;
  font-size: 30px;
  font-weight: 300;
  letter-spacing: 7px;
  color: #ffffff;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.85), 0 0 25px rgba(212, 175, 55, 0.35);
}

/* Línea inferior: 'EDITH' */
.segunda-linea {
  font-family: 'Cormorant Garamond', 'Cinzel', serif;
  font-size: 30px;
  font-weight: 300;
  letter-spacing: 7px;
  color: #ffffff;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.85), 0 0 25px rgba(212, 175, 55, 0.35);
}

/* Ocultar inicialmente para evitar parpadeos antes de GSAP */
.fotoportada-container,
.dark-overlay,
.mis-xv-wrapper,
.centered-container {
  opacity: 0;
}
</style>